let prevSaleTimeoutId;
const TIMEOUT_DURATION = 20000;

function showPreviousSaleBar(itemCount = 0, totalAmount = 0) {
  // Update the displayed item count and total amount
  $(".previousSaleItems").text(itemCount);
  $(".previousSaleTotal").each(function () {
    $(this).html(totalAmount + " <small>NOK</small>");
  });

  if (window.innerWidth < 700) {
    $("#previousSaleBar").css({ bottom: "2.5px" });
    $("#previousSaleBar").addClass("show");
  } else {
    if (!($("#checkout").width() > 0)) {
      $("#previousSaleDesktopBar").show();
    }
  }

  // Clear any existing timers
  clearTimeout(prevSaleTimeoutId);

  // Auto-hide after 20 seconds
  prevSaleTimeoutId = setTimeout(function () {
    hidePreviousSaleBar();
  }, TIMEOUT_DURATION);
}

function hidePreviousSaleBar() {
  clearTimeout(prevSaleTimeoutId);

  prevSaleTimeoutId = null;
  if (window.innerWidth < 700) {
    $("#previousSaleBar").css({ bottom: "-200px" });
    $("#previousSaleBar").removeClass("show");
  } else {
    $("#previousSaleDesktopBar").hide();
  }
}

$(function () {
  $(document).on(
    "touchstart mousedown",
    "#previousSaleBar, #previousSaleDesktopBar",
    function () {
      $(".confirmation-toast").css({ padding: "1rem" }).show();
      $(".confirmation-toast-box")
        .toast("show")
        .on("hidden.bs.toast", function () {
          $(".confirmation-toast").attr("style", function (i, s) {
            return (s || "") + "padding: 0px !important;";
          });
        });
    },
  );
});
